import client from './client'

// Main chat interface with Server-Sent Events streaming
const chatStream = async (body) => {
  return new Promise((resolve, reject) => {
    try {
      const token = localStorage.getItem('accessToken')
      const baseURL = client.defaults.baseURL || process.env.REACT_APP_API_URL + '/api/v1'
      
      // Use fetch API for streaming POST request with proper authentication
      fetch(`${baseURL}/agent-one/chat/stream`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : '',
          'Accept': 'text/event-stream',
          'Cache-Control': 'no-cache'
        },
        body: JSON.stringify(body)
      }).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''

        const processStream = () => {
          return reader.read().then(({ done, value }) => {
            if (done) {
              resolve({
                success: true,
                message: 'Stream completed',
                status: 'completed'
              })
              return
            }

            buffer += decoder.decode(value, { stream: true })
            const lines = buffer.split('\n')
            buffer = lines.pop() || '' // Keep incomplete line in buffer
            lines.forEach(line => {
              if (line.startsWith('data: ')) {
                try {
                  const data = JSON.parse(line.slice(6))
                  
                  if (data.type === 'token' && body.onToken) {
                    body.onToken(data.content, data.fullContent)
                  } else if (data.type === 'completed') {
                    resolve(data)
                    return
                  } else if (data.type === 'error') {
                    reject(new Error(data.error))
                    return
                  } else if (data.type === 'connected') {
                    console.log('SSE connection established:', data.sessionId)
                  }
                } catch (parseError) {
                  console.warn('Failed to parse SSE data:', line)
                }
              }
            })

            return processStream()
          })
        }

        return processStream()
      }).catch(error => {
        console.error('Streaming error:', error)
        reject(error)
      })

    } catch (error) {
      console.error('AgentOne chat stream error:', error)
      reject(error)
    }
  })
}

const chatStream2 = async (body) => {
  return new Promise((resolve, reject) => {
    try {
      const token = localStorage.getItem('accessToken')
      const baseURL = client.defaults.baseURL || process.env.REACT_APP_API_URL + '/api/v1'
      
      // Use fetch API for streaming POST request with proper authentication
      fetch(`${baseURL}/agent-one/chat2/stream`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : '',
          'Accept': 'text/event-stream',
          'Cache-Control': 'no-cache'
        },
        body: JSON.stringify(body)
      }).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''

        const processStream = () => {
          return reader.read().then(({ done, value }) => {
            if (done) {
              resolve({
                success: true,
                message: 'Stream completed',
                status: 'completed'
              })
              return
            }

            buffer += decoder.decode(value, { stream: true })
            const lines = buffer.split('\n')
            buffer = lines.pop() || '' // Keep incomplete line in buffer
            lines.forEach(line => {
              if (line.startsWith('data: ')) {
                try {
                  const data = JSON.parse(line.slice(6))
                  
                  if (data.type === 'token' && body.onToken) {
                    body.onToken(data.content, data.fullContent)
                  } else if (data.type === 'completed') {
                    resolve(data)
                    return
                  } else if (data.type === 'error') {
                    reject(new Error(data.error))
                    return
                  } else if (data.type === 'connected') {
                    console.log('SSE connection established:', data.sessionId)
                  }
                } catch (parseError) {
                  console.warn('Failed to parse SSE data:', line)
                }
              }
            })

            return processStream()
          })
        }

        return processStream()
      }).catch(error => {
        console.error('Streaming error:', error)
        reject(error)
      })

    } catch (error) {
      console.error('AgentOne chat stream error:', error)
      reject(error)
    }
  })
}

// Alternative non-streaming chat method
const chatWithoutStream = async (body) => {
  try {
    const response = await client.post('/agent-one/chat/no-stream', body)
    return response.data
  } catch (error) {
    console.error('AgentOne chat error:', error)
    throw error
  }
}
const getUserFlows = async (id) => client.get(`/agent-one/${id}`)
// Session management
const getChatHistory = (sessionId) => client.get(`/agent-one/session/${sessionId}/history`)

const clearChatSession = (sessionId) => client.delete(`/agent-one/session/${sessionId}`)

const agentOneApi = {
  chatStream,
  chatStream2,
  chatWithoutStream,
  getChatHistory,
  clearChatSession,
  getUserFlows
}

export default agentOneApi
